import React from 'react';
import SignupForm from '../components/auth/SignupForm';
import ParticleBackground from '../components/ParticleBackground';

const SignupPage: React.FC = () => {
  const handleSignupSuccess = () => {
    // Email signup now signs the user in. Google signup already goes to the app.
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      {/* Particle Background */}
      <ParticleBackground />
      
      {/* Signup Form Side - White Container */}
      <SignupForm onSignupSuccess={handleSignupSuccess} />
    </div>
  );
};

export default SignupPage;